export default __webpack_public_path__ + "static/media/dance-down-home.99494381.svg";